import { useFontStyle } from "~/hook/useFontStyle";
import { cn } from "~/lib/utils";

const NodataFound = ({ text }: { text: string }) => {
  const { medium } = useFontStyle();
  return (
    <div className="text-center flex justify-start items-center flex-col gap-5">
      <div className="size-52 rounded-full overflow-hidden flex justify-center items-center bg-gray-200">
        <img src="/images/noDataMaharaj.png" alt="maharaj_image" className="rounded-full object-cover select-none" />
      </div>
      <span className={cn("h2_heading font-bold text-textColor", medium)}>{text}</span>
    </div>
  );
};
export default NodataFound;
